(() => {
  const packageIcon = `
    <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" fill="none">
      <path d="M10 10.0859V18.1234" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.55469 6.00977L10 10.0848L17.4453 6.00977" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.175 14.2849L10.3 18.049C10.208 18.0993 10.1049 18.1257 10 18.1257C9.89515 18.1257 9.79198 18.0993 9.7 18.049L2.825 14.2849C2.72683 14.2312 2.64488 14.1521 2.58772 14.0559C2.53055 13.9597 2.50025 13.8499 2.5 13.738V6.2646C2.50025 6.1527 2.53055 6.04291 2.58772 5.94672C2.64488 5.85052 2.72683 5.77144 2.825 5.71772L9.7 1.95366C9.79198 1.90333 9.89515 1.87695 10 1.87695C10.1049 1.87695 10.208 1.90333 10.3 1.95366L17.175 5.71772C17.2732 5.77144 17.3551 5.85052 17.4123 5.94672C17.4695 6.04291 17.4997 6.1527 17.5 6.2646V13.7365C17.5 13.8486 17.4699 13.9587 17.4127 14.0552C17.3555 14.1517 17.2734 14.2311 17.175 14.2849Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6.37109 3.77344L13.7492 7.81172V11.8742" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

  const wrenchIcon = `
    <svg aria-hidden="true" focusable="false" viewBox="0 0 256 256" fill="currentColor">
      <path d="M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"/>
    </svg>`;

  function addAssemblyIcons() {
    document
      .querySelectorAll('.gpo-swatches.buttons input[data-field-name="Assembly"]')
      .forEach((input) => {
        const label = input.nextElementSibling;
        if (!label || label.querySelector('.qw-assembly-icon')) return;

        const icon = document.createElement('span');
        icon.className = 'qw-assembly-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = input.value.startsWith('Fully Assembled') ? wrenchIcon : packageIcon;
        label.prepend(icon);
      });
  }

  document.addEventListener('gpoRenderCompleted', addAssemblyIcons);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addAssemblyIcons, { once: true });
  } else {
    addAssemblyIcons();
  }

  window.setTimeout(addAssemblyIcons, 500);
  window.setTimeout(addAssemblyIcons, 1500);
})();
